<template>
	<h5 class="franchise_hed">
		<span>{{ $t('new_ui.agreement1_page.franchise_hed.title.one') }}</span> -
		{{ $t('new_ui.agreement1_page.franchise_hed.title.two') }}
	</h5>
	<div class="franchaise_box">
		<h4>{{ $t('new_ui.agreement1_page.franchaise_box_1st.title') }}</h4>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box_1st.paragraph') }}
		</p>
	</div>
	<div class="franchaise_box">
		<h4>{{ $t('new_ui.agreement1_page.franchaise_box.title') }}</h4>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box.paragraph.one') }}
		</p>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box.paragraph.two') }}
		</p>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box.paragraph.three') }}
		</p>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box.paragraph.four') }}
		</p>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box.paragraph.five') }}
		</p>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box.paragraph.six') }}
		</p>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box.paragraph.seven') }}
		</p>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box.paragraph.eight') }}
		</p>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box.paragraph.nine') }}
		</p>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box.paragraph.ten') }}
		</p>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box.paragraph.eleven') }}
		</p>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box.paragraph.twelve') }}
		</p>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box.paragraph.thirteen') }}
		</p>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box.paragraph.fourteen') }}
		</p>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box.paragraph.fifteen') }}
		</p>
	</div>
	<div class="franchaise_box">
		<h4>{{ $t('new_ui.agreement1_page.franchaise_box_2nd.title') }}</h4>
		<p>
			{{ $t('new_ui.agreement1_page.franchaise_box_2nd.paragraph') }}
		</p>
		<ul>
			<li>{{ $t('new_ui.agreement1_page.franchaise_box_2nd.list.one') }}</li>
			<li>
				{{ $t('new_ui.agreement1_page.franchaise_box_2nd.list.two') }}
			</li>
			<li>{{ $t('new_ui.agreement1_page.franchaise_box_2nd.list.three') }}</li>
			<li>
				{{ $t('new_ui.agreement1_page.franchaise_box_2nd.list.four') }}
			</li>
			<li>
				{{ $t('new_ui.agreement1_page.franchaise_box_2nd.list.five') }}
			</li>
			<li>
				{{ $t('new_ui.agreement1_page.franchaise_box_2nd.list.six') }}
			</li>
			<li>
				{{ $t('new_ui.agreement1_page.franchaise_box_2nd.list.seven') }}
			</li>
			<li>
				{{ $t('new_ui.agreement1_page.franchaise_box_2nd.list.eight') }}
			</li>
			<li>
				{{ $t('new_ui.agreement1_page.franchaise_box_2nd.list.nine') }}
			</li>
			<li>
				{{ $t('new_ui.agreement1_page.franchaise_box_2nd.list.ten') }}
			</li>
		</ul>
	</div>
	<div class="franchaise_box">
		<h4>Article 3: Establishment Of A Contract</h4>
		<p>
			The person who applies for the use of JPWorldPay (hereinafter referred to
			as "This applicant") shall, after approving these Terms and Conditions and
			the privacy policy prescribed by the Company, apply for the use of
			JPWorldPay in the prescribed manner.
		</p>
		<p>
			In applying for the use of JPWorldPay, this applicant represents and
			warrants that the materials to be submitted to the Company or what is
			reported to the Company are accurate and up-to-date.
		</p>
		<p>
			When the Company receives an application for use of JPWorldPay, the
			Company will conduct an examination of the applicant (hereinafter referred
			to as "Examination of the case"). Examination of the case includes
			examination by a credit card company and examination by a third party
			necessary to use each payment method in JPWorldPay (hereinafter, the
			company, the credit card company, and such third parties are collectively
			referred to as "Companies"). This applicant shall accept that depending on
			result of the examination of the case, it may not be possible to receive
			payment for products such as products by card.
		</p>
		<p>
			As a result of this examination, at the time when the Company accepts the
			application for use of JPWorldPay, with this applicant as a merchant, /
			Payment service use contract based on these terms and conditions
			(hereinafter referred to as the "Contract") and the contract based on the
			JPWorldPay Balance Merchant Agreement (for online payment) established by
			the Company are concluded. In addition to the provisions of these Terms
			and Conditions, the merchant must comply with the JPWorldPay Balance
			Merchant Terms and Conditions for payment by JPWorldPay balance in
			JPWorldPay according to each of the following subparagraph. In addition,
			if there are any other provisions that contradict or conflict with these
			Terms and Conditions in the JPWorldPay Balance Merchant Agreement, the
			provisions of these Terms and Conditions take precedence and for matters
			not stipulated in these Terms and Conditions, the JPWorldPay Balance
			Merchant Agreement shall apply to payment by JPWorldPay Balance.
		</p>
		<p>
			This applicant shall be deemed to have submitted the application for
			Article 3 and Article 4 of the JPWorldPay Balance Merchant Agreement by
			applying for use in accordance with Paragraph 1 of this Article.
		</p>
		<p>
			When a JPWorldPay user chooses to pay by JPWorldPay balance in the method
			prescribed by the Company as stipulated in Article 5, Paragraph 2 of the
			JPWorldPay Balance Merchant Terms and Conditions, if the sales
			confirmation processing stipulated in Article 11 paragraph 2 or Article
			11-2 paragraph 4 including the case where Article 11-2 paragraph 4 is
			applied based on Article 11-5 Paragraph 2 is completed, in accordance with
			Article 5 paragraph 2 of the Pay Balance Merchant Terms and Conditions,
			the Company will reduce the Pay balance and follow the provisions of the
			same Article.
		</p>
		<p>
			If there is a need to cancel the transaction prescribed in Article 8
			Paragraph 2 of the JPWorldPay Balance Merchant Agreement, it shall be
			carried out in accordance with Article 16 of this terms and conditions.
		</p>
		<p>
			Payment of the prescribed payment system usage fee, etc. in JPWorldPay
			Balance Merchant Agreement Article 11 and the settlement prescribed in
			Article 12 shall be carried out in accordance with Articles 13 and 14 of
			these terms and conditions.
		</p>
		<p>
			When the payment due to the JPWorldPay balance falls under any of the
			subparagraphs of Article 19 paragraph 1 of the JPWorldPay Balance Merchant
			Agreement, it is regarded as falling under each subparagraph of Article 18
			Paragraph 1 of these terms and conditions and handled in accordance with
			the provisions of paragraphs 2 through 6 of the same Article.
		</p>
		<p>
			When, as a result of this examination, the credit card company approved
			the application for the payment of the payment for products, etc. by card,
			between this applicant and the credit card company specified in each of
			the following subparagraphs, a card merchant contract based on the card
			merchant agreements (hereinafter referred to as "card merchant agreement")
			as stipulated in each of the following paragraphs depending on the credit
			card company is concluded.
		</p>
		<p>
			Card Company: The CompanyCard Merchant Agreement: The Postpaid Payment
			Merchant Terms and Conditions (for online payment)
		</p>
		<p>
			Card company: Card company notified separately by JPWorldPayCard Merchant
			Agreement: Card Merchant Agreement notified separately by the Company
		</p>
		<p>
			The Company does not disclose the progress of examination of the case, the
			reasons for the results, etc.
		</p>
		<p>
			Merchant agrees in advance that information about merchants may be posted
			on the Company, website of a third party designated by the Company, and
			promotional materials, etc. and that the publication may be discontinued
			at the discretion of the Company, or a third party designated by the
			Company. Do the same for information about additional or changed merchants
			in accordance with the following paragraphs.
		</p>
		<p>
			In case of additions or changes to the merchant information reported
			pursuant to paragraph 2, the merchant shall report it in advance by the
			Company's prescribed method.
		</p>
	</div>
</template>
